/*
 *   This file is part of 6502.ts, an emulator for 6502 based systems built
 *   in Typescript
 *
 *   Copyright (c) 2014 -- 2020 Christian Speckner and contributors
 *
 *   Permission is hereby granted, free of charge, to any person obtaining a copy
 *   of this software and associated documentation files (the "Software"), to deal
 *   in the Software without restriction, including without limitation the rights
 *   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 *   copies of the Software, and to permit persons to whom the Software is
 *   furnished to do so, subject to the following conditions:
 *
 *   The above copyright notice and this permission notice shall be included in all
 *   copies or substantial portions of the Software.
 *
 *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 *   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 *   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 *   SOFTWARE.
 */

export const NTSC = new Uint32Array([
    0xff000000,
    0xff4a4a4a,
    0xff6f6f6f,
    0xff8e8e8e,
    0xffaaaaaa,
    0xffc0c0c0,
    0xffd6d6d6,
    0xffececec,
    0xff004848,
    0xff0f6969,
    0xff1d8686,
    0xff2aa2a2,
    0xff35bbbb,
    0xff40d2d2,
    0xff4ae8e8,
    0xff54fcfc,
    0xff002c7c,
    0xff114890,
    0xff2162a2,
    0xff307ab4,
    0xff3d90c3,
    0xff4aa4d2,
    0xff55b7df,
    0xff60c8ec,
    0xff001c90,
    0xff1539a3,
    0xff2853b5,
    0xff3a6cc6,
    0xff4a82d5,
    0xff5997e3,
    0xff67aaf0,
    0xff74bcfc,
    0xff000094,
    0xff1a1aa7,
    0xff3232b8,
    0xff4848c8,
    0xff5c5cd6,
    0xff6f6fe4,
    0xff8080f0,
    0xff9090fc,
    0xff640084,
    0xff7a1997,
    0xff8f30a8,
    0xffa246b8,
    0xffb359c6,
    0xffc36cd4,
    0xffd27ce0,
    0xffe08cec,
    0xff840050,
    0xff9a1968,
    0xffad307d,
    0xffc04692,
    0xffd059a4,
    0xffe06cb5,
    0xffee7cc5,
    0xfffc8cd4,
    0xff900014,
    0xffa31a33,
    0xffb5324e,
    0xffc64868,
    0xffd55c7f,
    0xffe36f95,
    0xfff080a9,
    0xfffc90bc,
    0xff940000,
    0xffa71a18,
    0xffb8322d,
    0xffc84842,
    0xffd65c54,
    0xffe46f65,
    0xfff08075,
    0xfffc9084,
    0xff881c00,
    0xff9d3b18,
    0xffb0572d,
    0xffc27242,
    0xffd28a54,
    0xffe1a065,
    0xffefb575,
    0xfffcc884,
    0xff643000,
    0xff805018,
    0xff986d2d,
    0xffb08842,
    0xffc5a054,
    0xffd9b765,
    0xffebcc75,
    0xfffce084,
    0xff304000,
    0xff4e6218,
    0xff69812d,
    0xff829e42,
    0xff99b854,
    0xffaed165,
    0xffc2e775,
    0xffd4fc84,
    0xff004400,
    0xff1a661a,
    0xff328432,
    0xff48a048,
    0xff5cba5c,
    0xff6fd26f,
    0xff80e880,
    0xff90fc90,
    0xff003c14,
    0xff185f35,
    0xff2d7e52,
    0xff429c6e,
    0xff54b787,
    0xff65d09e,
    0xff75e7b4,
    0xff84fcc8,
    0xff003830,
    0xff165950,
    0xff2b766d,
    0xff3e9288,
    0xff4faba0,
    0xff5fc2b7,
    0xff6ed8cc,
    0xff7cece0,
    0xff002c48,
    0xff144d69,
    0xff266a86,
    0xff3886a2,
    0xff479fbb,
    0xff56b6d2,
    0xff63cce8,
    0xff70e0fc
]);

export const PAL = new Uint32Array([
    0xff000000,
    0xff2b2b2b,
    0xff525252,
    0xff767676,
    0xff979797,
    0xffb6b6b6,
    0xffd2d2d2,
    0xffececec,
    0xff000000,
    0xff2b2b2b,
    0xff525252,
    0xff767676,
    0xff979797,
    0xffb6b6b6,
    0xffd2d2d2,
    0xffececec,
    0xff005880,
    0xff1a7196,
    0xff3287ab,
    0xff489cbe,
    0xff5cafcf,
    0xff6fc0df,
    0xff80d1ee,
    0xff90e0fc,
    0xff005c44,
    0xff1a795e,
    0xff329376,
    0xff48ac8c,
    0xff5cc2a0,
    0xff6fd7b3,
    0xff80eac4,
    0xff90fcd4,
    0xff003470,
    0xff1a5189,
    0xff326ba0,
    0xff4884b6,
    0xff5c9ac9,
    0xff6fafdc,
    0xff80c2ec,
    0xff90d4fc,
    0xff146400,
    0xff35801a,
    0xff529832,
    0xff6eb048,
    0xff87c55c,
    0xff9ed96f,
    0xffb4eb80,
    0xffc8fc90,
    0xff140070,
    0xff351a89,
    0xff5232a0,
    0xff6e48b6,
    0xff875cc9,
    0xff9e6fdc,
    0xffb480ec,
    0xffc890fc,
    0xff5c5c00,
    0xff76761a,
    0xff8e8e32,
    0xffa4a448,
    0xffb8b85c,
    0xffcbcb6f,
    0xffdcdc80,
    0xffecec90,
    0xff5c0070,
    0xff741a84,
    0xff893296,
    0xff9e48a8,
    0xffb05cb7,
    0xffc16fc6,
    0xffd180d3,
    0xffe090e0,
    0xff703c00,
    0xff895a19,
    0xffa0752f,
    0xffb68e44,
    0xffc9a557,
    0xffdcba68,
    0xffecce79,
    0xfffce088,
    0xff700058,
    0xff891a6e,
    0xffa03283,
    0xffb64896,
    0xffc95ca7,
    0xffdc6fb7,
    0xffec80c6,
    0xfffc90d4,
    0xff702000,
    0xff893f19,
    0xffa05a2f,
    0xffb67444,
    0xffc98b57,
    0xffdca168,
    0xffecb579,
    0xfffcc888,
    0xff800034,
    0xff961a4a,
    0xffab325f,
    0xffbe4872,
    0xffcf5c83,
    0xffdf6f93,
    0xffee80a2,
    0xfffc90b0,
    0xff880000,
    0xff9d1a1a,
    0xffb03232,
    0xffc24848,
    0xffd25c5c,
    0xffe16f6f,
    0xffef8080,
    0xfffc9090,
    0xff000000,
    0xff2b2b2b,
    0xff525252,
    0xff767676,
    0xff979797,
    0xffb6b6b6,
    0xffd2d2d2,
    0xffececec,
    0xff000000,
    0xff2b2b2b,
    0xff525252,
    0xff767676,
    0xff979797,
    0xffb6b6b6,
    0xffd2d2d2,
    0xffececec
]);

export const SECAM = new Uint32Array([
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff,
    0xff000000,
    0xffff2121,
    0xff793cf0,
    0xffff50ff,
    0xff00ff7f,
    0xffffff7f,
    0xff3fffff,
    0xffffffff
]);
